import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMixer = (props) => /* @__PURE__ */ _jsx("svg", {
	height: "800px",
	width: "800px",
	id: "_x32_",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 512 512",
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M496.446,420.572h-62.161v36.571h62.161c8.59,0,15.554-6.964,15.554-15.554v-5.464 C512,427.536,505.036,420.572,496.446,420.572z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M0,436.125v5.464c0,8.59,6.964,15.554,15.554,15.554h290.732v-36.571H15.554 C6.964,420.572,0,427.536,0,436.125z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M375.759,365.714h-10.946c-17.179,0-31.098,13.928-31.098,31.098v84.089c0,17.17,13.919,31.098,31.098,31.098 h10.946c17.178,0,31.098-13.928,31.098-31.098v-84.089C406.857,379.642,392.937,365.714,375.759,365.714z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M496.446,237.696H214.125v36.572h282.322c8.59,0,15.554-6.964,15.554-15.553v-5.464 C512,244.661,505.036,237.696,496.446,237.696z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M15.554,274.268h70.571v-36.572H15.554C6.964,237.696,0,244.661,0,253.25v5.464 C0,267.303,6.964,274.268,15.554,274.268z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M144.652,182.839c-17.178,0-31.098,13.929-31.098,31.098v84.09c0,17.17,13.92,31.098,31.098,31.098h10.946 c17.179,0,31.098-13.928,31.098-31.098v-84.09c0-17.169-13.92-31.098-31.098-31.098H144.652z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M15.554,91.428H236.91V54.857H15.554C6.964,54.857,0,61.821,0,70.411v5.464 C0,84.464,6.964,91.428,15.554,91.428z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M496.446,54.857H364.911v36.571h131.536c8.59,0,15.554-6.964,15.554-15.554v-5.464 C512,61.821,505.036,54.857,496.446,54.857z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M295.438,146.286h10.946c17.178,0,31.098-13.928,31.098-31.098V31.098c0-17.17-13.92-31.098-31.098-31.098 h-10.946c-17.179,0-31.098,13.928-31.098,31.098v84.089C264.339,132.358,278.259,146.286,295.438,146.286z"
		})
	] })
});
export default SvgMixer;
